<template>
  <section class="radio-color-picker">
    <div :class="gridClass">
      <div v-for="item in items" :key="item.value">
        <input 
        :type="multipe? 'checkbox' : 'radio'"  
        :v-model="multipe ? colors : color"   
        :name="multipe ? '' : 'bodyColor'" 
        :key="item.value"  
        :id="item.value" 
        :value="item.value" 
        @change="inputChange"
        :checked="(props.colors)?(props.colors.includes(item.value)) : false"
        />
        <label class="rounded-label" :for="item.value">
          <span :class="'color-'+item.value"></span>
          <i class="material-symbols-rounded fsz-16">check</i>
        </label>
        <label class="picker-label cursor-pointer" :for="item.value">{{item.value}}</label>
        
      </div>
    </div>
  </section>
</template>

<script setup lang="ts">
const emit = defineEmits<{
  (e: 'update:colors', val: any): void
}>()

const props = defineProps<{
  colors?:  string | string[],
  gridClass : string ,
  multipe?: boolean ,
}>()

const color = ref<string | string[]>('');
const colors = ref<string[]>([]);

const inputChange = (e: any) => {
  const newValue = e.target.value;
  
  if (!props.multipe) {
    color.value = newValue;
    emit('update:colors', newValue);
    return;
  } else {
    const updatedColors = Array.isArray(props.colors) 
      ? [...props.colors] 
      : [];
    
    // Check if the color is already in the array
    const index = updatedColors.indexOf(newValue);
    
    // If the color is not present, add it; otherwise, remove it
    if (index === -1) {
      updatedColors.push(newValue);
    } else {
      updatedColors.splice(index, 1);
    }

    colors.value = updatedColors;
    emit('update:colors', updatedColors);
  }
};
/* const color = computed({
  // getter
  get() {

     return props.colors
  },
  // setter
  set(newValue) {
    // Note: we are using destructuring assignment syntax here
console.log(newValue);
   
    emit('update:colors' , newValue)
  }
})*/

onBeforeMount(()=>{
  if (props.multipe) {
    color.value = []
  }
})

const items = ref([
  {
    value: "Noir",
  },
  {
    value: "Blanc",
  },
  {
    value: "Rouge",
  },
  {
    value: "Violet",
  },
  {
    value: "Jaune",
  },
  {
    value: "Gris",
  },
  {
    value: "Beige",
  },
  {
    value: "Vert",
  },
  {
    value: "Or",
  },
  {
    value: "Argent",
  },
  {
    value: "Brun",
  },
  {
    value: "Bleu",
  },
  {
    value: "Orange",
  },
  {
    value : "Autre"
  }
])

</script>
<style lang="scss" scoped>
</style>